import { c as _c } from "react/compiler-runtime";
import { LoadingOutlined } from '@ant-design/icons';
import styles from './RectButton.module.css';
interface RectButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outlined' | 'ghost' | 'dark' | 'danger';
  isLoading?: boolean;
  testId?: string;
  'data-testid'?: string;
  fullWidth?: boolean;
}
export default function RectButton(t0) {
  const $ = _c(18);
  let children;
  let dataTestId;
  let isLoading;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t0) {
    ({
      variant: t1,
      className: t2,
      isLoading,
      children,
      testId: t3,
      fullWidth: t4,
      "data-testid": dataTestId,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = dataTestId;
    $[3] = isLoading;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    children = $[1];
    dataTestId = $[2];
    isLoading = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  const variant = t1 === undefined ? "primary" : t1;
  const className = t2 === undefined ? "" : t2;
  const testId = t3 === undefined ? "" : t3;
  const fullWidth = t4 === undefined ? false : t4;
  const resolvedTestId = dataTestId ?? `rect-submit${testId}-${variant}`;
  const t5 = `${styles.rectButton} ${styles[variant]} ${fullWidth ? styles.fullWidth : ""} ${className}`;
  let t6;
  if ($[9] !== children || $[10] !== isLoading) {
    t6 = isLoading ? <LoadingOutlined /> : children;
    $[9] = children;
    $[10] = isLoading;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isLoading || $[13] !== props || $[14] !== resolvedTestId || $[15] !== t5 || $[16] !== t6) {
    t7 = <button disabled={isLoading} className={t5} data-testid={resolvedTestId} {...props}>{t6}</button>;
    $[12] = isLoading;
    $[13] = props;
    $[14] = resolvedTestId;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}